<template>
  <ModalContainer queryParam="rc" ref="modalContainer" size="lg">

    <b-alert v-if="messageAlert" show :variant="messageAlert.variant" class="p-2 text-center">
      {{ messageAlert.text }}
    </b-alert>

    <b-card class="mb-0">
      <h4 class="text-center mb-1">VALORACIÓN DE RIESGO DE CAÍDAS</h4>

      <div class="mb-2" v-if="dataProceso">
        <div><b>Paciente: </b> {{ dataProceso.paciente }}</div>
        <div><b>Procedimiento:</b> {{ dataProceso.codigo }} - {{ dataProceso.descripcion }}</div>
      </div>

      <hr>
      <div class="row text-primary">
        <div class="col-4">
          <span>Fecha</span>
          <flat-pickr size="sm" class="form-control" v-model="dataForm.fecha" locale="es" :config="birthDateConfig" />
        </div>
        <div class="col-8">
          <span>Auxiliar Responsable</span>
          <SearchOpts v-model="dataForm.auxiliar" :searchService="auxiliarService.searchAuxiliaresByTermSelect"
            :placeholder="'Buscar auxiliar...'" class="col-10" :minChars="3" />
        </div>
      </div>
      <hr>

      <h5 class="my-2">Escala de Downton</h5>

      <div class="row">
        <h5 class="col-3">Items</h5>
        <div class="col-8">
          <b-row>
            <div class="col-6"></div>
            <div class="col-2">Ingreso</div>
            <div class="col-2">Egreso</div>
          </b-row>
        </div>
      </div>
      <hr>

      <div v-for="(category, categoryKey) in dataForm.info" :key="categoryKey" class="row">

        <h5 class="col-3">{{ category.label }}</h5>
        <div class="col-8">
          <b-row v-for="(item, itemKey) in category.items" :key="itemKey" class="mb-1">
            <div class="col-7">{{ item.label }}</div>

            <b-form-checkbox v-model="item.ingreso" class="col-2" @change="calculateTotal" />

            <b-form-checkbox v-model="item.egreso" class="col-2" @change="calculateTotal" />

          </b-row>
        </div>

        <hr class="col-12">

      </div>

      <div class="row">
        <h5 class="col-3">TOTAL:</h5>
        <div class="col-8">
          <b-row>
            <div class="col-7"></div>
            <div class="col-2" style="font-size: 18px;">{{ dataForm.totalIngreso }}</div>
            <div class="col-2" style="font-size: 18px;">{{ dataForm.totalEgreso }}</div>
          </b-row>
        </div>
      </div>

      <div class="mt-3 my-2 d-flex justify-content-end">
        <b-button variant="primary" @click="onSaveForm">
          Guardar
        </b-button>
      </div>
    </b-card>
  </ModalContainer>
</template>

<script>
import { ModalContainer } from "@/shared/components";
import { getDataForms } from "../../helpers/getDataForms";
import { procedimientosFormulariosService, procedimientosService } from "../../services";
import { auxiliarService } from "../../../../shared/services";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import SearchOpts from "../../../../shared/components/SearchOpts/SearchOpts.vue";

export default {
  name: "RiesgoCaidas",

  components: {
    ModalContainer,
    flatPickr,
    SearchOpts
  },

  created() {
    this.loadData();
  },

  data() {
    return {
      auxiliarService,
      auxiliar: null,
      fechaActual: null,
      messageAlert: null,
      tokenFormulario: null,
      procedimientosService,
      tokenProceso: null,
      dataProceso: null,
      idRegistroForm: null,

      codigoFormulario: 'rc',

      dataForm: {},

      dataFormDefault: {
        auxiliar: null,
        fecha: null,
        info: {
          caidasPrevias: {
            label: "Caídas Previas",
            items: {
              no: {
                label: "No",
                ingreso: false,
                egreso: false,
                points: 0
              },

              si: {
                label: "Sí",
                ingreso: false,
                egreso: false,
                points: 1
              },
            },
          },

          medicamentos: {
            label: "Medicamentos",
            items: {
              ninguno: {
                label: "Ninguno",
                ingreso: false,
                egreso: false,
                points: 0
              },

              tranquilizantes: {
                label: "Tranquilizantes - sedantes",
                ingreso: false,
                egreso: false,
                points: 1
              },

              diureticos: {
                label: "Diuréticos",
                ingreso: false,
                egreso: false,
                points: 1
              },

              hipotensores: {
                label: "Hipotensores (no diuréticos)",
                ingreso: false,
                egreso: false,
                points: 1
              },
              antiparkinsonianos: {
                label: "Antiparkinsonianos",
                ingreso: false,
                egreso: false,
                points: 1
              },
              antidepresivos: {
                label: "Antidepresivos",
                ingreso: false,
                egreso: false,
                points: 1
              },
              otros: {
                label: "Otros medicamentos",
                ingreso: false,
                egreso: false,
                points: 1
              },
            },
          },

          sensorial: {
            label: "Sensorial",
            items: {
              ninguno: {
                label: "Ninguno",
                ingreso: false,
                egreso: false,
                points: 0
              },

              alteracionesVisuales: {
                label: "Alteraciones Visuales",
                ingreso: false,
                egreso: false,
                points: 1
              },

              alteracionesAuditivas: {
                label: "Alteraciones Auditivas",
                ingreso: false,
                egreso: false,
                points: 1
              },

              extremidades: {
                label: "Problemas en Extremidades",
                ingreso: false,
                egreso: false,
                points: 1
              },
            },
          },

          estadoMental: {
            label: "Estado Mental",
            items: {
              orientado: {
                label: "Orientado",
                ingreso: false,
                egreso: false,
                points: 0
              },

              confuso: {
                label: "Confuso",
                ingreso: false,
                egreso: false,
                points: 1
              },
            },
          },

          deambulacion: {
            label: "Deambulación",
            items: {
              normal: {
                label: "Normal",
                ingreso: false,
                egreso: false,
                points: 0
              },

              seguraAyuda: {
                label: "Segura con ayuda",
                ingreso: false,
                egreso: false,
                points: 1
              },

              inseguraAyuda: {
                label: "Insegura con ayuda",
                ingreso: false,
                egreso: false,
                points: 1
              },

              imposible: {
                label: "Imposible",
                ingreso: false,
                egreso: false,
                points: 1
              },
            },
          },
        },

        totalIngreso: 0,
        totalEgreso: 0,
      },


    };
  },


  methods: {


    async loadData() {
      this.dataForm = { ...this.dataFormDefault };


      this.tokenProceso = this.$route.query.forms;
      this.tokenFormulario = this.$route.query.rc

      const responseDataProceso = await procedimientosService.getByToken(this.tokenProceso);


      if (responseDataProceso) {



        const persona = responseDataProceso.consultamedica.cita.paciente.persona;

        this.dataProceso = {
          codigo: responseDataProceso.procedimiento.codigo,
          descripcion: responseDataProceso.procedimiento.descripcion,
          paciente: `${persona.identificacion} - ${persona.primerApellido} ${persona.primerNombre}`
        }
      }
      const response = await procedimientosFormulariosService.obtenerFormProcDataByToken(this.tokenFormulario);

      this.messageAlert = {
        text: 'Informacion por registrar',
        variant: 'info'
      };

      if (!response) {

        return
      }


      this.messageAlert = {
        text: "Info cargada",
        variant: "success"
      };

      let dataForm = null
      try {
        dataForm = JSON.parse(response.dataJson)
      } catch (error) { console.log("Eror", error) }

      console.log("data form", dataForm)
      if (dataForm) { this.dataForm = dataForm; }

    },


    async onSaveForm() {



      const params = {
        nameForm: this.codigoFormulario,
        dataJson: JSON.stringify(this.dataForm),
        tokenProceso: this.tokenProceso,
        tokenFormulario: this.tokenFormulario,
        idRegistroForm: this.idRegistroForm,
      };

      const responseSave = await procedimientosFormulariosService.guardarData(params);

      if (!responseSave) {
        this.$swal({
          title: "Error",
          text: "No se guardo! Contacte al equipo de desarrollo",
          icon: "error",
          confirmButtonColor: "#089599",
        });

        return;
      }

      await this.$swal.fire({
        icon: "success",
        text: "Guardado correctamente",
      });

     
      
      await this.$router.push({ query: { ...this.$route.query, rc: undefined } });
      this.$emit("formulario-guardado");
      //this.$router.go(0);
    },

    calculateTotal() {
      let ingreso = 0;
      let egreso = 0;
      Object.values(this.dataForm.info).forEach(category => {
        Object.values(category.items).forEach(item => {
          if (item.ingreso) ingreso += item.points;
          if (item.egreso) egreso += item.points;
        });
      });
      this.dataForm.totalIngreso = ingreso;
      this.dataForm.totalEgreso = egreso;
      this.dataForm.total = ingreso + egreso
    },
  },

  watch: {
    '$route.query.rc': {
      handler(newValue) {
        if (newValue) {
          this.loadData();
        }
      }
    }
  }
};
</script>
